import React, { useEffect, useState } from "react";
import MDTypography from "components/MDTypography";
import {
  IconButton,
  MenuItem,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  DialogContent,
  TextField,
  Switch,
  Divider,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import CTLDialogContent from "application/components/styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";
import MicIcon from "@mui/icons-material/Mic";

function AgentRecording({ row, setUpdateList, callCenter, onChange }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const originalRecording = row?.record;
  const CallCenterRecording = row?.original?.record;
  const agentNameForCallCenter = row?.original?.name;
  const [showAlert, setShowAlert] = useState(false);
  const [checked, setChecked] = useState(
    callCenter ? CallCenterRecording : originalRecording
  );
  const [isChanged, setIsChanged] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  useEffect(() => {
    if (!showAlert) {
      setNotify({
        isOpen: false,
        message: "",
        type: "",
        pagename: "",
        status: "",
      });
    }
    setChecked(callCenter ? CallCenterRecording : originalRecording);
    setIsChanged(false);
  }, [showAlert]);

  const handleFinalSubmit = () => {
    setShowAlert(true);
  };

  const handleSubmit = () => {
    const finalValue = isChanged
      ? checked
      : callCenter
      ? CallCenterRecording
      : originalRecording;
    const contactData = {
      agentName: callCenter ? agentNameForCallCenter : row?.agent,
      record: finalValue,
    };
    application
      .post("/agent/updateAgentContact", contactData)
      .then((response) => {
        if (callCenter) {
          onChange();
        } else {
          setUpdateList(Date.now());
        }
        setNotify({
          isOpen: true,
          status: response.data.messageDetail,
          type: "success",
          pagename: "Agent Contact",
        });
        setTimeout(() => {
          setShowAlert(false);
        }, 1000);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status: error.response.data.messageDetail,
          type: "error",
          pagename: "Agent Contact",
        });
      });
  };

  const handleCancel = () => {
    setShowAlert(false);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setIsChanged(true);
  };

  return (
    <>
      <MDTypography variant="caption" fontWeight="medium" color="text">
        <tooltip title="Recording">
          <IconButton color="success" onClick={handleFinalSubmit}>
            <MicIcon />
          </IconButton>
        </tooltip>
      </MDTypography>

      <Dialog
        open={showAlert}
        onClose={handleCancel}
        aria-labelledby="confirmation-dialog-title"
      >
        <DialogTitle
          sx={(theme) => CTLDialogContent(theme, { darkMode })}
          id="alert-dialog-title"
        >
          Agent Recording:{row.agent}
        </DialogTitle>
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDBox
            sx={{
              mt: 3,
              width: 300,
              display: "flex",
              alignItems: "center",
              gap: 15,
            }}
          >
            <MDTypography variant="body1" fontWeight="medium">
              Recording
            </MDTypography>
            <Switch
              checked={checked}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
              sx={{
                "& .MuiSwitch-thumb": {
                  bgcolor: checked ? "green" : "red",
                },
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleCancel} color="secondary">
            Cancel
          </MDButton>
          <MDButton onClick={handleSubmit} color="success" autoFocus>
            Submit
          </MDButton>
        </DialogActions>
        <CTLNotification notify={notify} setNotify={setNotify} />
      </Dialog>
    </>
  );
}

export default AgentRecording;
